import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShowItemComponent} from './show/show-item.component';
import {ShowTextComponent} from './show/show-text.component';
import {LayoutTitleComponent} from './layout/layout-title.component';
import {RouterModule} from '@angular/router';
import {ShowLayoutComponent} from './show/show-layout.component';
import {ListLayoutComponent} from './list/list-layout.component';
import {FormLayoutComponent} from './forms/form-layout.component';
import {FormTemplateTextComponent} from './forms/form-template-text.component';
import {FormTemplateTextAreaComponent} from './forms/form-template-textarea.component';
import {FormTemplateValoreAttributiComponent} from './forms/form-template-valore-attributi.component';

import {FormTemplateDatepickerComponent} from './forms/form-template-datepicker.component';
import {ButtonNewComponent} from './buttons/button-new.component';
import {ButtonCsvComponent} from './buttons/button-csv.component';
import {ButtonSaveComponent} from './buttons/button-save.component';
import {ButtonCancelComponent} from './buttons/button-cancel.component';
import {ButtonBackComponent} from './buttons/button-back.component';
import {ButtonsLayoutComponent} from './buttons/buttons-layout.component';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AlertModule} from 'ngx-bootstrap/alert';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {ListItemComponent} from './list/list-item.component';
import {ButtonCrudComponent} from './buttons/button-crud.component';
import {ButtonDeleteComponent} from './buttons/button-delete.component';
import {ListHeaderLayoutComponent} from './list/list-header-layout.component';
import {EditHeaderLayoutComponent} from './layout/layout-edit-header.component';
import {FormTemplateCheckboxComponent} from './forms/form-template-checkbox.component';
import {ShowEnumComponent} from './show/show-enum.component';
import {FormTemplateSelectModelComponent} from './forms/form-template-select-model.component';
import {FormTemplateButtonEventComponent} from './forms/form-template-button-event.component';
import {TableItemComponent} from './table/table-item.component';
import {WizardComponent} from './wizard/wizard.component';
import {WizardItemComponent} from './wizard/wizard-item.component';
import {WizardItemContentComponent} from './wizard/wizard-item-content.component';
import {FormValidationErrorLayoutComponent} from './forms/form-validation-error-layout.component';
import {ShowMultiComponent} from './show/show-multi.component';
import {LayoutBreadcrumbsComponent} from './layout/layout-breadcrumbs.component';
import {LayoutLegendComponent} from './layout/layout-legend.component';
import {LayoutWaitComponent} from './layout/layout-wait.component';
import {AttachmentComponent} from './attachments/attachment.component';
import {AttachmentListComponent} from './attachments/attachment-list.component';
import {AttachmentModalComponent} from './attachments/attachment-modal.component';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormTemplateColorPickerComponent} from './forms/form-template-colorpicker.component';
import {FormTemplateAttributiComponent} from './forms/form-template-attributi.component';
import {ShowAttributiComponent} from './show/show-attributi.component';
import {ShowColorComponent} from './show/show-color.component';
import {ShowBooleanComponent} from './show/show-boolean.component';
import {TranslatePipe} from './translate/translate.pipe';
import { BodyLayoutComponent } from './layout/layout-body.component';
import { FooterLayoutComponent } from './layout/layout-footer.component';

@NgModule({
  declarations: [

    // Layout
    LayoutTitleComponent,
    LayoutBreadcrumbsComponent,
    LayoutLegendComponent,
    LayoutWaitComponent,
    FormTemplateAttributiComponent,
    
    // Form
    FormLayoutComponent,
    FormValidationErrorLayoutComponent,

    FormTemplateTextComponent,
    FormTemplateTextAreaComponent,
    FormTemplateCheckboxComponent,
    FormTemplateDatepickerComponent,
    FormTemplateSelectModelComponent,
    FormTemplateButtonEventComponent,
    FormTemplateColorPickerComponent,
    FormTemplateValoreAttributiComponent,

    // Buttons
    ButtonsLayoutComponent,

    ButtonNewComponent,
    ButtonCsvComponent,
    ButtonSaveComponent,
    ButtonCancelComponent,
    ButtonBackComponent,
    ButtonCrudComponent,
    ButtonDeleteComponent,

    // Show
    ShowLayoutComponent,
    ShowEnumComponent,
    ShowTextComponent,
    ShowMultiComponent,
    ShowColorComponent,
    ShowAttributiComponent,
    ShowBooleanComponent,
    ShowItemComponent,

    // List
    ListLayoutComponent,
    ListHeaderLayoutComponent,
    ListItemComponent,
    TableItemComponent,


    // Edit
    BodyLayoutComponent,
    FooterLayoutComponent,
    EditHeaderLayoutComponent,

    // Wizard
    WizardComponent,
    WizardItemComponent,
    WizardItemContentComponent,

    // Attachement
    AttachmentComponent,
    AttachmentListComponent,
    AttachmentModalComponent,

    // Translate
    TranslatePipe

  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    ColorPickerModule
  ],
  exports: [
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    CollapseModule,
    AlertModule,
    PaginationModule,
    TooltipModule,
    PopoverModule,
    ColorPickerModule,

    // Layout
    LayoutTitleComponent,
    LayoutBreadcrumbsComponent,
    LayoutLegendComponent,
    LayoutWaitComponent,
    FormTemplateAttributiComponent,

    // Form
    FormTemplateTextComponent,
    FormTemplateTextAreaComponent,
    FormTemplateCheckboxComponent,
    FormTemplateDatepickerComponent,
    FormTemplateSelectModelComponent,
    FormTemplateButtonEventComponent,
    FormValidationErrorLayoutComponent,
    FormTemplateColorPickerComponent,
    FormTemplateValoreAttributiComponent,

    // Buttons
    ButtonsLayoutComponent,

    ButtonNewComponent,
    ButtonCsvComponent,
    ButtonSaveComponent,
    ButtonCancelComponent,
    ButtonBackComponent,
    ButtonCrudComponent,
    ButtonDeleteComponent,

    // Show
    ShowEnumComponent,
    ShowTextComponent,
    ShowMultiComponent,
    ShowColorComponent,
    ShowAttributiComponent,
    ShowBooleanComponent,
    ShowItemComponent,

    // List
    ListLayoutComponent,
    ListHeaderLayoutComponent,
    ListItemComponent,
    TableItemComponent,

    // Edit
    BodyLayoutComponent,
    FooterLayoutComponent,
    EditHeaderLayoutComponent,

    // Wizard
    WizardComponent,
    WizardItemComponent,
    WizardItemContentComponent,

    // Attachment
    AttachmentComponent,
    AttachmentListComponent,
    AttachmentModalComponent,

    // Translate
    TranslatePipe
  ],
  providers: [
    BsModalService,
    BsModalRef,
  //   I18n
  //   // {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
  //   // {provide: NgbDateParserFormatter, useClass: NgbDateItParserFormatter}
   ],
   bootstrap: [AttachmentModalComponent]
})
export class AceTagsModule {}
